export default "__VITE_ASSET__d4233011__"